<template>
  <div>
    <head-nav-bar title="订单详情" :fixed="true"> </head-nav-bar>
    <div class="mt-header-nav confirm-box rest-order-box">
      <cell-box style="padding: 5px 0;" :column="2">
        <cell-item label="联系人：">
          <div slot="value">
            {{ orderInfo.Contact }}
            <van-tag type="danger" v-if="orderInfo.Status == 4" plain>{{
              orderInfo.StatusName
            }}</van-tag>
            <van-tag
              type="success"
              plain
              v-else-if="orderInfo.Status != 0 && orderInfo.Status != 13"
              >{{ orderInfo.StatusName }}</van-tag
            >
            <van-tag color="#f90" plain v-else>{{
              orderInfo.StatusName
            }}</van-tag>
          </div>
        </cell-item>
        <cell-item label="就餐人数：" :value="orderInfo.PersonCount" />
        <cell-item label="桌台：" :value="tableName" />
        <cell-item label="订单号：" :value="orderInfo.No" />
        <cell-item label="电话：" :value="orderInfo.Phone" />
        <cell-item
          label="会员卡："
          v-if="orderInfo.MemberName"
          :value="orderInfo.MemberName"
        />
        <cell-item v-if="Number(orderInfo.Discount) > 0" label="折扣：">
          <template slot="value">
            {{ orderInfo.Discount }}
            <van-button
              size="mini"
              type="danger"
              @click="cancelDiscount"
              v-if="orderInfo.Status != 4 && orderInfo.Status != 2"
            >
              取消折扣</van-button
            >
          </template>
        </cell-item>
        <cell-item
          label="订餐时间："
          style="gridColumn:span 2;"
          :value="orderInfo.CheckInTime"
          v-if="orderInfo.CheckInTime"
        />
        <cell-item
          label="备注："
          style="gridColumn:span 2;"
          :value="orderInfo.OrderRemark"
          v-if="orderInfo.OrderRemark"
        />
      </cell-box>
      <van-tabs v-model="activeTab">
        <van-tab title="菜品信息" name="1"> </van-tab>
        <van-tab title="支付记录" name="2"> </van-tab>
      </van-tabs>
      <div v-if="activeTab == 1">
        <h3 class="selected-title">
          下单菜品
        </h3>
        <van-tabs
          v-model="active"
          type="card"
          class="table-names"
          @change="changeTab"
          color="#f50"
          v-if="
            orderInfo && orderInfo.DishTables && orderInfo.DishTables.length > 1
          "
        >
          <van-tab
            :title="item.TableName"
            v-for="item in orderInfo.DishTables"
            :key="item.TableId"
            :name="item.TableId"
          >
          </van-tab>
        </van-tabs>
        <div
          class="select-foods detail-select-table"
          :class="{
            'only-one-table':
              orderInfo.DishTables && orderInfo.DishTables.length == 1,
          }"
        >
          <template v-for="item in orderFoodList">
            <van-card :key="item.DishId">
              <template #price>
                <div style="color:#555">
                  <span>&yen;{{ item.UnitPrice }} x {{ item.Quantity }}</span>
                  <span
                    v-if="Number(orderInfo.Discount) > 0"
                    class="discount-amount"
                    >(折扣金额：&yen;{{ item.DiscountPrice }})</span
                  >
                  <van-tag type="success" v-if="item.HadPay">已付款</van-tag>
                </div>
              </template>
              <template #title>
                <div class="food-title">
                  <span>
                    {{ item.AccountItemName }}
                    <span
                      v-if="item.PracticeDesc || item.CookingMethodDesc"
                      class="method-txt"
                    >
                      「做法」{{ item.PracticeDesc
                      }}{{ item.CookingMethodDesc }}
                    </span>
                    <span
                      v-if="
                        item.IsUnconfirmed &&
                          orderInfo.Status != 13 &&
                          orderInfo.Status != 0 &&
                          orderInfo.Status != 4
                      "
                      ><van-tag type="danger" mark plain>待确认</van-tag></span
                    >
                    <span v-if="item.IsPack">
                      <van-tag color="#f60" @click="openPack(item)"
                        >套餐&nbsp;<van-icon
                          :name="
                            openKeys.includes(item.DishId) ||
                            openKeys.includes(item.Id)
                              ? 'arrow-up'
                              : 'arrow-down'
                          "
                      /></van-tag>
                    </span>
                  </span>
                </div>
              </template>
              <template #num>
                <span style="color:#f00"> &yen;{{ item.FinalPrice }}</span>
              </template>
              <template v-if="item.IsPack" #footer>
                <ul
                  class="pack-detail"
                  :class="{
                    'pack-detail-open':
                      openKeys.includes(item.DishId) ||
                      openKeys.includes(item.Id),
                  }"
                >
                  <li v-for="pack in item.PackDetails" :key="pack.Id">
                    {{ pack.Name }} x {{ pack.Quantity }}
                  </li>
                </ul>
              </template>
            </van-card>
          </template>
        </div>
        <div class="table-info">
          <van-button
            class="to-table "
            size="small"
            @click="cancelTable"
            v-if="currentTable.OrderStatus == 1"
            >取消桌台</van-button
          >
          <span></span>
          <div>
            <span class="status-name"
              >桌台状态：{{ currentTable.OrderStatusName }}</span
            >
            <van-button
              class="to-table"
              type="info"
              size="small"
              @click="toTable"
              v-if="
                currentTable.OrderStatus != 2 && currentTable.OrderStatus != 4
              "
              >进入桌台</van-button
            >
            <van-button
              class="to-table"
              type="info"
              size="small"
              @click="antiSettleTable"
              v-if="currentTable.OrderStatus == 2"
              >反结</van-button
            >
          </div>
        </div>
        <van-goods-action>
          <div slot="default" class="price-info">
            <van-row>
              <van-col :span="12">
                消费：<em class="price">&yen; {{ orderInfo.TotalAmount }}</em>
              </van-col>
              <van-col :span="12">
                折后：<em class="price">&yen; {{ orderInfo.FinalAmount }}</em>
              </van-col>
            </van-row>

            <van-row>
              <van-col :span="12">
                抹零：<em class="price"
                  >&yen; {{ orderInfo.FreeRemnantAmount }}</em
                >
              </van-col>
              <van-col :span="12">
                付款：<em class="price">&yen; {{ orderInfo.PayAmount }}</em>
              </van-col>
            </van-row>
          </div>
          <van-goods-action-button
            type="warning"
            text="结账"
            @click="chekout"
            v-if="orderInfo.Status == 1 || orderInfo.Status == 12"
          />
          <van-goods-action-button
            type="warning"
            text="反结"
            @click="antiSettle"
            v-if="orderInfo.Status == 2"
          />
        </van-goods-action>
      </div>
      <div v-if="activeTab == 2">
        <div v-if="payments.length" class="payments-table">
          <table>
            <tr>
              <th>台号</th>
              <th>账务名称</th>
              <th>单价</th>
              <th>数量</th>
              <th>总价</th>
              <th>折扣金额</th>
              <th>折后价</th>
            </tr>
            <tr v-for="item in payments" :key="item.Id">
              <td>{{ item.TableName }}</td>
              <td>{{ item.AccountItemName }}</td>
              <td>{{ item.UnitPrice }}</td>
              <td>{{ item.Quantity }}</td>
              <td>{{ item.TotalPrice }}</td>
              <td>{{ item.DiscountPrice }}</td>
              <td>{{ item.FinalPrice }}</td>
            </tr>
          </table>
        </div>
        <div v-else class="no-data">暂无数据！</div>
      </div>
    </div>
    <TableOperate
      ref="TableOperate"
      :dishTables="orderInfo && orderInfo.DishTables"
      :orderId="orderId"
      @update="getDetail"
      @submit="getTableIds"
    ></TableOperate>
  </div>
</template>

<script>
import "./restarant.less";
import { CellBox, CellItem } from "@/components/cell";
import restaurantManageApi from "@/api/restaurantManage.js";
import {
  Cell,
  CellGroup,
  Field,
  Button,
  Card,
  Tag,
  Icon,
  Dialog,
  Toast,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Tab,
  Tabs,
  Notify,
  Row,
  Col,
} from "vant";
import restaurantApi from "@/api/restaurant.js";
import TableOperate from "./TableOperate.vue";
import { accAdd } from "@/utils/common";
export default {
  name: "CreateOrder",
  components: {
    CellBox,
    CellItem,
    TableOperate,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Card.name]: Card,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton,
  },
  data() {
    return {
      orderId: "",
      tableId: "",
      orderInfo: {},
      orderFoodList: [],
      tableName: "",
      total: {
        Quantity: 0,
        TotalPrice: 0,
      },
      openKeys: [],
      currentTable: {}, //当前桌台
      active: "",
      activeTab: "1",
      payments: [],
    };
  },
  created() {
    this.orderId = this.$route.query.orderId;
    if (this.orderId) {
      this.getDetail();
    } else {
      const _this = this;
      Dialog.alert({
        message: "暂无订单！",
        theme: "round-button",
      }).then(() => {
        _this.$router.push({
          name: "restarantManageIndex",
        });
      });
    }
  },
  methods: {
    init() {
      let num = 0;
      this.orderFoodList.forEach(item => {
        num = accAdd(num, item.Quantity);
      });
      this.total.Quantity = num;
    },
    changeTab(val) {
      this.currentTable = this.orderInfo.DishTables.find(
        el => el.TableId == val,
      );
      this.orderFoodList = this.currentTable.DishAccounts;
    },
    toTable() {
      // this.$router.push({
      //   name: "restarantManageOrderFood",
      //   query: {
      //     orderId: this.orderInfo.Id,
      //     tableId: this.currentTable.TableId
      //   }
      // });
      this.$router.push({
        name: "restarantManageDetail",
        query: {
          orderId: this.orderInfo.Id,
          tableId: this.currentTable.TableId,
        },
      });
    },
    getDetail() {
      restaurantApi.getOrderDetail({ Id: this.orderId }).then(res => {
        this.orderInfo = res.Data;
        this.currentTable = res.Data.DishTables[0];
        this.orderFoodList = this.currentTable.DishAccounts;
        this.tableName = res.Data.DishTables.map(v => v.TableName).join(",");
        this.total.TotalPrice = this.orderInfo.TotalAmount;
        this.payments = this.orderInfo.Payments;
        this.init();
      });
    },
    openPack(item) {
      let id = item.Id ? item.Id : item.DishId;
      if (this.openKeys.includes(id)) {
        this.openKeys = this.openKeys.filter(el => el != id);
      } else {
        this.openKeys.push(id);
      }
    },
    chekout() {
      const openTableList = this.orderInfo.DishTables.filter(
        el => el.OrderStatus != 2,
      );

      if (openTableList.length > 1) {
        this.$refs.TableOperate.onShow(this.currentTable, 3);
      } else if (openTableList.length == 1) {
        this.$router.push({
          name: "restarantManageCheckout",
          query: {
            orderId: this.orderId,
            tableIds: openTableList[0].TableId,
          },
        });
      }
    },
    getTableIds(ids) {
      this.submitAnti(ids);
    },
    antiSettle() {
      const tableList = this.orderInfo.DishTables.filter(
        el => el.OrderStatus == 2,
      );
      if (tableList.length > 1) {
        this.$refs.TableOperate.onShow(this.currentTable, 4);
      } else if (tableList.length == 1) {
        const _this = this;
        Dialog.confirm({
          title: "确认反结桌台【" + tableList[0].TableName + "】吗？",
        })
          .then(() => {
            _this.submitAnti([tableList[0].TableId]);
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    antiSettleTable() {
      const { currentTable } = this;
      const _this = this;
      Dialog.confirm({
        title: "确认反结桌台【" + currentTable.TableName + "】吗？",
      })
        .then(() => {
          _this.submitAnti([currentTable.TableId]);
        })
        .catch(() => {
          // on cancel
        });
    },
    submitAnti(ids) {
      restaurantManageApi
        .antiSettle({
          OrderId: this.orderId,
          TableIds: ids,
        })
        .then(() => {
          Notify({ type: "success", message: "操作成功" });
          this.getDetail();
        });
    },
    cancelTable() {
      const { orderId, currentTable } = this;
      const _this = this;
      Dialog.confirm({
        title: "确认取消桌台【" + currentTable.TableName + "】吗？",
      }).then(() => {
        restaurantManageApi
          .cancelOrder({
            Id: orderId,
            TableIds: [currentTable.TableId],
          })
          .then(() => {
            Notify({ type: "success", message: "操作成功" });
            _this.getDetail();
          });
      });
    },
    cancelDiscount() {
      const _this = this;
      Dialog.confirm({
        title: "确定取消折扣吗？",
      }).then(() => {
        restaurantManageApi
          .discount({
            Id: _this.orderId,
            Discount: 0,
            IsPreview: false,
          })
          .then(() => {
            Notify({ type: "success", message: "操作成功" });
            _this.getDetail();
          });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.detail-select-table {
  height: calc(100vh - 353px);
  padding-bottom: 0;
  overflow: auto;
  &.only-one-table {
    height: calc(100vh - 323px);
  }
}
.price-info {
  font-size: 13px;
  width: 50%;
  padding-left: 5px;

  .price {
    color: #f00;
  }
}
.custom-dropdown /deep/.van-dropdown-menu__title::after {
  display: none;
}
.payments-table {
  table {
    width: 100%;
  }
  th,
  td {
    font-size: 12px;
    padding: 3px 0;
    border: 1px solid #eee;
  }
  th {
    font-weight: normal;
    background: #09a8d1;
    color: #fff;
    text-align: center;
  }
  td {
    text-align: center;
  }
}
.table-info {
  display: flex;
  background: #fafafa;
  justify-content: space-between;
  padding: 0 10px;
  button {
    margin-top: 3px;
  }
  .status-name {
    margin-right: 10px;
    font-size: 14px;
    line-height: 36px;
    color: #666;
  }
}
.table-names {
  margin: 0 -16px;
}
.rest-order-box .van-goods-action {
  height: 46px;
}
.discount-txt {
  float: right;
  margin-top: 3px;
  margin-right: 5px;
}
.discount-amount {
  margin-left: 10px;
  color: #f60;
  font-size: 12px;
}
.free-amount {
  float: right;
  margin-right: 5px;
  font-size: 14px;
  strong {
    color: #f00;
  }
}
.no-data {
  text-align: center;
  color: #666;
  padding: 20px;
}
</style>
